// extracted by mini-css-extract-plugin
export default {"outer_box":"LeftBar_outer_box__ZpEon"};